export default {
  awmac: require('./wmac_wizard.json'),
  nlrme2: require('./nlrme2.json')
}
